import * as turf from "@turf/turf";
import { HashSetNumber } from "../../../../shared/HashSetNumber";
export class SegmentDataTools {
    /**
     * Gets the length in meters.
     * @param segment The segment.
     * @returns The length.
     */
    static getLength(segment) {
        return turf.length(turf.feature(segment.geometry)) * 1000.0;
    }
    /**
     * Gets the scores from the attributes.
     *
     * @param segment The segment.
     * @param forward The forward flag.
     * @returns The scores in a structured object.
     */
    static getScore(segment, forward) {
        if (forward) {
            if (typeof segment.attributes["_score:bicycle:right"] === "undefined") {
                return {};
            }
            return {
                comfort: Number(segment.attributes["_score:bicycle:right"]),
                safety: Number(segment.attributes["_score:bicycle:right"]),
            };
        }
        else {
            if (typeof segment.attributes["_score:bicycle:left"] === "undefined") {
                return {};
            }
            return {
                comfort: Number(segment.attributes["_score:bicycle:left"]),
                safety: Number(segment.attributes["_score:bicycle:left"]),
            };
        }
    }
    /**
     * Creates all the features to render the segment and the details.
     *
     * @param segment
     * @param referenceSegment
     * @param func
     */
    static forEachFeature(segment, func, referenceSegment) {
        // do forward.
        let cuts = new HashSetNumber();
        segment.assignments.forEach(a => {
            if (!a.forward)
                return;
            cuts.set(a.tailOffset ?? 0);
            cuts.set(a.headOffset ?? 65536);
        });
        if (typeof referenceSegment !== "undefined") {
            referenceSegment.assignments.forEach(a => {
                if (!a.forward)
                    return;
                cuts.set(a.tailOffset ?? 0);
                cuts.set(a.headOffset ?? 65536);
            });
        }
        // create linestring.
        let lineString = turf.lineString(segment.geometry.coordinates);
        let length = turf.length(lineString);
        // build parts
        // 99% of the time this is a single segment.
        let sortedCuts = cuts.entries().sort((n1, n2) => n1 - n2);
        for (let i = 1; i < sortedCuts.length; i++) {
            const tailOffset = sortedCuts[i - 1];
            const headOffset = sortedCuts[i];
            let partLineString = lineString;
            if (tailOffset > 0 || headOffset < 65536) {
                const tailLength = (tailOffset / 65536.0) * length;
                const headLength = (headOffset / 65536.0) * length;
                partLineString = turf.lineSliceAlong(lineString, tailLength, headLength);
            }
            // copy attributes.   
            const properties = {};
            for (const key in segment.attributes) {
                properties[key] = segment.attributes[key];
            }
            // set global properties.
            properties["_id"] = segment.globalId;
            properties["_forward"] = true;
            properties["_tail_offset"] = tailOffset;
            properties["_head_offset"] = headOffset;
            const feature = turf.feature(partLineString.geometry, properties);
            func(feature);
        }
        // do backward
        cuts = new HashSetNumber();
        segment.assignments.forEach(a => {
            if (a.forward)
                return;
            cuts.set(a.tailOffset ?? 0);
            cuts.set(a.headOffset ?? 65536);
        });
        if (typeof referenceSegment !== "undefined") {
            referenceSegment.assignments.forEach(a => {
                if (a.forward)
                    return;
                cuts.set(a.tailOffset ?? 0);
                cuts.set(a.headOffset ?? 65536);
            });
        }
        // create linestring.
        const reversedCoordinates = [...segment.geometry.coordinates];
        reversedCoordinates.reverse();
        lineString = turf.lineString(reversedCoordinates);
        length = turf.length(lineString);
        // build parts
        // 99% of the time this is a single segment.
        sortedCuts = cuts.entries().sort((n1, n2) => n1 - n2);
        for (let i = 1; i < sortedCuts.length; i++) {
            const tailOffset = sortedCuts[i - 1];
            const headOffset = sortedCuts[i];
            let partLineString = lineString;
            if (tailOffset > 0 || headOffset < 65536) {
                const tailLength = (tailOffset / 65536.0) * length;
                const headLength = (headOffset / 65536.0) * length;
                partLineString = turf.lineSliceAlong(lineString, tailLength, headLength);
            }
            // copy attributes.   
            const properties = {};
            for (const key in segment.attributes) {
                properties[key] = segment.attributes[key];
            }
            // set global properties.
            properties["_id"] = segment.globalId;
            properties["_forward"] = false;
            properties["_tail_offset"] = tailOffset;
            properties["_head_offset"] = headOffset;
            const feature = turf.feature(partLineString.geometry, properties);
            func(feature);
        }
    }
}
